export default __webpack_public_path__ + "static/media/9.302c71fb.jpg";